import { render, staticRenderFns } from "./jobname.vue?vue&type=template&id=28e8dc2e&scoped=true"
import script from "./jobname.vue?vue&type=script&lang=js"
export * from "./jobname.vue?vue&type=script&lang=js"
import style0 from "./jobname.vue?vue&type=style&index=0&id=28e8dc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8dc2e",
  null
  
)

export default component.exports